import { UserAvatar } from "components/Atoms/Avatar";
import { Message } from "semantic-ui-react";
import React from "react";
import { newLineToBr } from "utilities";

interface Props<T extends server.dto.Activity<any>> {
  button?: React.ReactNode
  error?: string | null
  activity: T
  cardColor?: "green" | "orange" | "purple" | "gray-dark" | "gray" | "blue";
  getTitle: () => string
  getSubtitle: () => string[]
  getSubtitleHover: () => string
}

const ActivityCard = <T extends server.dto.Activity<any>>(props: React.PropsWithChildren<Props<T>>) => {
  const { actor, actorName } = props.activity;
  const cardStyle = props.cardColor
    ? {
      borderLeft: `solid 6px var(--${props.cardColor})`,
      display: "block",
    } : {
      display: "block",
    };

  return <div style={cardStyle}>
    <div className="flex gap">
      <div className="grow1 flex-column gap-small">
        <div className="flex">
          <div className="grow1">
            <>
              {(actorName != null) && <span className="s1_transparent60">{actorName} </span>}
              <strong>{props.getTitle()}</strong>
            </>
          </div>
        </div>

        {props.children}
      </div>

      {(actor) && <div>
        <UserAvatar user={actor} size="avatar-30" />
      </div>}
    </div>

    <div className="flex gap align-center">
      <div className="grow1 s1_small" title={props.getSubtitleHover()}>
        <span className="s1_gray">{props.getSubtitle().join(" | ")}</span>
      </div>
      {props.button && <div>
        {props.button}
      </div>}
    </div>

    {props.error && <Message color="red">
      {props.error}
    </Message>}
  </div>;
};

interface DefaultActivityContentProps {
  contentStyle?: React.CSSProperties
  activity: server.dto.Activity<any>
}

export const DefaultActivityContent = (props: DefaultActivityContentProps) => {
  if (!props.activity.content) return null;

  return <div className="flex">
    <div style={{ width: 3 }} className="gray-bg"></div>
    <div style={props.contentStyle} className="grow1 padding-small">
      {newLineToBr(props.activity.content)}
    </div>
  </div>;
}

interface ClickableActivityContentProps {
  value: string | null
  onClick: () => void
}

export const ClickableActivityContent = (props: ClickableActivityContentProps) => {
  if (!props.value) return null;

  return <div className="flex">
    <div style={{ width: 3 }} className="gray-bg"></div>
    <div className="grow1 padding-small">
      <a onClick={props.onClick}>{props.value}</a>
    </div>
  </div>
}

export default ActivityCard;